import React from "react";
import { string, number, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import GoogleAuth from "../../atoms/google-auth";
import FacebookAuth from "../../atoms/facebook-auth";

import { setMember, setLoading, setUserPlans } from "../../helper/actions";
import { getUserMetaData } from "../../utils/utils";
import { getMyPlans, setAccessTypeUser } from "../../helper/access-type";

import "./login-pay.m.css";

const LoginPay = ({ googleClientId, facebookId, setMember, setLoading, setUserPlans }) => {
  const initiateCallback = () => {
    window.dataLayer.push({
      event: "login_try",
      login_initiate_page: "/plan-selection",
      login_initiate_position: "",
    });
  };

  const setUpUserFlow = (user) => {
    const metadata = getUserMetaData(user);
    global.AccessType &&
      setAccessTypeUser(user.email, metadata.mobileNumber, user.id, user.name).then(() => {
        getMyPlans().then((plans) => {
          setUserPlans(plans);
        });
      });
  };

  return (
    <div styleName="wrapper">
      <span styleName="login-pay">LOGIN & PAY</span>

      <div styleName="social-wrapper">
        <GoogleAuth
          text="Google"
          googleClientId={googleClientId}
          setMember={setMember}
          setLoading={setLoading}
          initiateCallback={initiateCallback}
          setUpUserFlow={setUpUserFlow}
        />

        <FacebookAuth
          text="Facebook"
          facebookId={facebookId}
          setMember={setMember}
          setLoading={setLoading}
          initiateCallback={initiateCallback}
          setUpUserFlow={setUpUserFlow}
        />
      </div>

      <div styleName="different-email">or pay using a different email id</div>

      <div styleName="terms-conditions">By subscribing you agree to our T&C.</div>
    </div>
  );
};

LoginPay.propTypes = {
  googleClientId: string,
  facebookId: number,
  setMember: func,
  setLoading: func,
  setUserPlans: func,
};

const mapStateToProps = (state) => ({
  googleClientId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "google"], ""),
  facebookId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "fb"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  setMember: (member) => dispatch(setMember(member)),
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  setUserPlans: (plans) => dispatch(setUserPlans(plans)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPay);
